import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getGallectionStreamId } from '../helpers';
import { getCurrentMediaSource, getTopLevelGallections } from '../selectors';
import { fetchMoreGallections } from '../actions';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';
const mapStateToProps = (state)=>{
    const mediaSource = getCurrentMediaSource(state);
    const streamId = getGallectionStreamId(mediaSource);
    const putScrapsFolderLast = (a, b)=>b.folderId === SCRAPS_FOLDER_ID ? -1 : 0;
    const gallections = getTopLevelGallections(state).sort(putScrapsFolderLast);
    return {
        gallections,
        hasMoreGallections: selectors.hasMore(state, streamId),
        isFetchingGallections: selectors.isFetching(state, streamId),
        isGallectionStreamInitialized: selectors.isInitialized(state, streamId)
    };
};
const mapDispatchToProps = {
    fetchMoreGallections
};
export const useGallections = ()=>_object_spread({}, useMMSelector(mapStateToProps), useMMDispatchActions({
        fetchMoreGallections
    }));
export default connectMediaStore(mapStateToProps, mapDispatchToProps);
